import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Header from 'components/Header/Header';
import { Svg, Loading } from '@jg/components';
import facebookLogoWhite from '@jg/styles/lib/assets/icons/facebook-white.svg';
import { getParticipantFirstName, getParticipantPageUrl, getParticipantPageName } from 'selectors/apiSelectors/apiSelectors';
import { isRequestInFlight } from 'selectors/httpSelectors/httpSelectors';

import './SummaryPage.scss';

export class SummaryPage extends React.Component {
  static propTypes = {
    participantFirstName: PropTypes.string,
    participantPageUrl: PropTypes.string,
    participantPageName: PropTypes.string,
    participantCallIsInFlight: PropTypes.bool,
  };

  static defaultProps = {
    participantFirstName: '',
    participantPageUrl: '',
    participantPageName: '',
    participantCallIsInFlight: true,
  };

  share = (event) => {
    event.preventDefault();

    const { participantPageUrl } = this.props;

    window.FB.ui({
      method: 'share',
      href: participantPageUrl,
    });
  }

  render() {
    const {
      participantFirstName,
      participantPageUrl,
      participantPageName,
      participantCallIsInFlight,
    } = this.props;

    return (
      <div className="summary-page">
        <Header step="4" />
        <div className="summary-page__body container">
          { participantCallIsInFlight ? <Loading size="large" /> : (
            <div>
              <img src="/src/assets/png/match-miles.png" className="summary-page__main-image" alt="" />
              <p className="summary-page__running">You’re off and running, {participantFirstName}!</p>
              <p className="summary-page__share-more">Remember the more you share, the more people will match your miles</p>

              { participantPageUrl && (
                <div className="summary-page__share-btn__wrapper">
                  <a href="" className="summary-page__share-btn" onClick={this.share}>
                    <Svg markup={facebookLogoWhite} alt="Facebook Icon" />
                    Share to Facebook
                  </a>
                </div>
              )}

              <div className="summary-page__fundraising-page">
                <p>See your MATCHmyMILES page</p>
                { participantPageUrl ? (
                  <p><a href={participantPageUrl}>{participantPageName}</a></p>
                ) : (
                  <p><a href="https://profile.justgiving.com/#/Fundraising">profile.justgiving.com</a></p>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default connect(
  (state) => ({
    participantCallIsInFlight: isRequestInFlight('participant')(state),
    participantFirstName: getParticipantFirstName(state),
    participantPageUrl: getParticipantPageUrl(state),
    participantPageName: getParticipantPageName(state),
  }),
)(SummaryPage);



// WEBPACK FOOTER //
// ./layouts/SummaryPage/SummaryPage.js